import { render } from "./hoverEffect13.vue?vue&type=template&id=04785af2"
import script from "./hoverEffect13.vue?vue&type=script&lang=js"
export * from "./hoverEffect13.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__